import * as React from 'react';

import { cn } from '@/lib/utils';

export interface StatusPillProps extends React.HTMLAttributes<HTMLSpanElement> {
  state: 'on' | 'off' | 'pause' | 'absence';
  /** Tiempo legible en mono — "4h 11m". El componente lo formatea aparte. */
  duration?: string;
}

const StatusPill = ({
  state,
  duration,
  className,
  children,
  ...props
}: StatusPillProps) => {
  const tone =
    state === 'on'
      ? 'border-success bg-success/10 text-success'
      : state === 'pause'
        ? 'border-warning bg-warning/10 text-warning'
        : state === 'absence'
          ? 'border-icaria-200 bg-icaria-100 text-icaria-700'
          : 'border-line-strong bg-card text-ink-2';

  const label =
    children ??
    (state === 'on'
      ? 'Fichado'
      : state === 'pause'
        ? 'En pausa'
        : state === 'absence'
          ? 'Ausencia'
          : 'No fichado');

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2.5 rounded-full border px-3.5 py-1.5 text-xs font-medium',
        tone,
        className,
      )}
      role="status"
      {...props}
    >
      {state === 'on' && (
        <span className="relative inline-block h-2 w-2 rounded-full bg-current">
          <span className="absolute -inset-[3px] rounded-full border border-current animate-pulse-ring" />
        </span>
      )}
      <span>{label}</span>
      {duration && (
        <span className="font-mono font-semibold tabular-nums">{duration}</span>
      )}
    </span>
  );
};

export { StatusPill };
